/* eslint no-useless-concat:0 */

interface CsvColumn {
	fieldNames: string[];
	label: string;
	format?: string;
	processor?: string;
	processorData?: {
		script?: string;
		key?: string;
		fields?: string;
		arrayPath?: string;
		subProcessor?: {
			format: string;
			fieldNames: string[];
			delimiter: string;
		};
	};
}

export const getCsvLabels = (columns, customFieldDefinitions) => {
	const dataInput: CsvColumn[] = [
		{
			fieldNames: ['task.companyTaskId'],
			label: 'task_id',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return "T" + data["task.companyTaskId"]',
			},
		},
		{
			fieldNames: ['task.parentCompanyTaskId'],
			label: 'parent_task_id',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.parentCompanyTaskId"]' + ' ? "T" + data["task.parentCompanyTaskId"]' + ' : "";',
			},
		},
		{
			fieldNames: ['task.name'],
			label: 'task_name',
			format: 'STRING',
		},
	];
	columns['task.project.info'] &&
		dataInput.push({
			fieldNames: ['task.project.companyProjectId', 'task.project.customProjectId'],
			label: 'project_id',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.project.customProjectId"]',
			},
		});
	columns['task.project.info'] && dataInput.push({fieldNames: ['task.project.name'], label: 'project_name'});
	columns['task.project.deadline'] && dataInput.push({fieldNames: ['task.project.deadline'], label: 'project_deadline_date'});
	columns['task.project.stage'] && dataInput.push({fieldNames: ['task.project.stage'], label: 'project_stage'});
	columns['task.project.rateCard.name'] && dataInput.push({fieldNames: ['task.project.rateCard.name'], label: 'rate_card'});
	columns['task.project.client.info'] && dataInput.push({fieldNames: ['task.project.client.name'], label: 'client_name'});
	columns['task.dates.start'] && dataInput.push({fieldNames: ['task.dates.start'], label: 'task_start_date'});
	columns['task.dates.deadline'] && dataInput.push({fieldNames: ['task.dates.deadline'], label: 'task_end_date'});
	columns['task.dates.createdAt'] && dataInput.push({fieldNames: ['task.dates.createdAt'], label: 'task_created_at'});
	columns['task.role.info'] && dataInput.push({fieldNames: ['task.role.name'], label: 'assigned_role'});
	columns['task.assignees'] &&
		dataInput.push({
			fieldNames: ['task.assignees.firstName', 'task.assignees.lastName'],
			label: 'Assignees',
			format: 'STRING',
			processor: 'LIST',
			processorData: {
				arrayPath: 'task.assignees',
				subProcessor: {
					format: 'STRING',
					fieldNames: ['firstName', 'lastName'],
					delimiter: ' ',
				},
			},
		});
	columns['task.status.name'] && dataInput.push({fieldNames: ['task.status.name'], label: 'task_status'});
	columns['task.phase.info'] && dataInput.push({fieldNames: ['task.phase.name'], label: 'phase_name'});
	columns['task.phase.dates.start'] && dataInput.push({fieldNames: ['task.phase.dates.start'], label: 'phase_start_date'});
	columns['task.phase.dates.deadline'] &&
		dataInput.push({fieldNames: ['task.phase.dates.deadline'], label: 'phase_end_date'});
	columns['task.sprint.info'] && dataInput.push({fieldNames: ['task.sprint.name'], label: 'sprint_name'});
	columns['task.deliverable.info'] &&
		dataInput.push({fieldNames: ['task.deliverable.name'], label: 'deliverable_name', format: 'STRING'});
	columns['task.sprint.dates.start'] && dataInput.push({fieldNames: ['task.sprint.dates.start'], label: 'sprint_start_date'});
	columns['task.sprint.dates.deadline'] &&
		dataInput.push({fieldNames: ['task.sprint.dates.deadline'], label: 'sprint_end_date'});
	columns['task.progress'] &&
		dataInput.push({
			fieldNames: ['task.progress'],
			label: 'progress',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.progress"] + \'%\' ;',
			},
		});

	columns['task.hours.estimated'] &&
		dataInput.push({
			fieldNames: ['task.work.estimate', 'task.project.estimationUnit'],
			label: 'estimated_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.project.estimationUnit"] === "HOURS" ? (data["task.work.estimate"] ? (data["task.work.estimate"] / 60).toFixed(2) : "0.00") : "";',
			},
		});
	columns['task.hours.actual'] &&
		dataInput.push({
			fieldNames: ['task.financial.billableActualMinutes', 'task.financial.nonBillableActualMinutes'],
			label: 'actual_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return ((parseInt(data["task.financial.billableActualMinutes"] || 0) + parseInt(data["task.financial.nonBillableActualMinutes"] || 0)) / 60).toFixed(2);',
			},
		});
	columns['task.hours.actual_billable'] &&
		dataInput.push({
			fieldNames: ['task.financial.billableActualMinutes'],
			label: 'actual_billable_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.billableActualMinutes"] ? (parseInt(data["task.financial.billableActualMinutes"]) / 60).toFixed(2) : "0.00";',
			},
		});
	columns['task.hours.actual_non_billable'] &&
		dataInput.push({
			fieldNames: ['task.financial.nonBillableActualMinutes'],
			label: 'actual_non_billable_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.nonBillableActualMinutes"] ? (parseInt(data["task.financial.nonBillableActualMinutes"]) / 60).toFixed(2) : "0.00";',
			},
		});
	columns['task.hours.remaining'] &&
		dataInput.push({
			fieldNames: ['task.work.remaining', 'task.project.estimationUnit'],
			label: 'remaining_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.project.estimationUnit"] === "HOURS" ? (data["task.work.remaining"] ? (data["task.work.remaining"] / 60).toFixed(2) : "0.00") : "";',
			},
		});
	columns['task.hours.projected'] &&
		dataInput.push({
			fieldNames: ['task.reported.projected'],
			label: 'projected_total_hours',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.reported.projected"] ? (parseInt(data["task.reported.projected"]) / 60).toFixed(2) : "0.00";',
			},
		});
	columns['task.hours.estimated_points'] &&
		dataInput.push({
			fieldNames: ['task.work.estimate', 'task.project.estimationUnit'],
			label: 'estimated_points',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.project.estimationUnit"] === "POINTS" ? (data["task.work.estimate"] ? parseFloat(data["task.work.estimate"]).toFixed(2) : "0.00") : "";',
			},
		});
	columns['task.hours.remaining_work_points'] &&
		dataInput.push({
			fieldNames: ['task.work.remaining', 'task.project.estimationUnit'],
			label: 'remaining_work_points',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.project.estimationUnit"] === "POINTS" ? (data["task.work.remaining"] ? parseFloat(data["task.work.remaining"]).toFixed(2) : "0.00") : "";',
			},
		});
	columns['task.financials.estimated_billable_value_of_service'] &&
		dataInput.push({
			fieldNames: ['task.financial.billablePlannedTimeAndExpenses'],
			label: 'estimated_billable_value_of_service',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.billablePlannedTimeAndExpenses"] ? parseFloat(data["task.financial.billablePlannedTimeAndExpenses"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.actual_billable_value_of_service'] &&
		dataInput.push({
			fieldNames: ['task.financial.billableActualTimeAndExpenses'],
			label: 'actual_billable_value_of_service',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.billableActualTimeAndExpenses"] ? parseFloat(data["task.financial.billableActualTimeAndExpenses"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.remaining_work_billable_value_of_service'] &&
		dataInput.push({
			fieldNames: ['task.financial.billableForecastTimeAndExpensesToComplete'],
			label: 'remaining_work_billable_value_of_service',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.billableForecastTimeAndExpensesToComplete"] ? parseFloat(data["task.financial.billableForecastTimeAndExpensesToComplete"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.projected_total_billable_value_of_service'] &&
		dataInput.push({
			fieldNames: ['task.financial.billableTotalTimeAndExpensesAtCompletion'],
			label: 'projected_total_billable_value_of_service',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.billableTotalTimeAndExpensesAtCompletion"] ? parseFloat(data["task.financial.billableTotalTimeAndExpensesAtCompletion"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.estimated_revenue'] &&
		dataInput.push({
			fieldNames: ['task.financial.revenue.planned'],
			label: 'estimated_revenue',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.revenue.planned"] ? parseFloat(data["task.financial.revenue.planned"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.actual_revenue'] &&
		dataInput.push({
			fieldNames: ['task.financial.revenue.actual'],
			label: 'actual_revenue',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.revenue.actual"] ? parseFloat(data["task.financial.revenue.actual"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.remaining_work_revenue'] &&
		dataInput.push({
			fieldNames: ['task.financial.totalForecastRevenueToComplete'],
			label: 'remaining_work_revenue',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.totalForecastRevenueToComplete"] ? parseFloat(data["task.financial.totalForecastRevenueToComplete"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.projected_total_revenue'] &&
		dataInput.push({
			fieldNames: ['task.financial.totalRevenueRecognition'],
			label: 'projected_total_revenue',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.totalRevenueRecognition"] ? parseFloat(data["task.financial.totalRevenueRecognition"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.financials.projected_over_under_servicing'] &&
		dataInput.push({
			fieldNames: ['task.financial.surplus'],
			label: 'projected_over_under_servicing',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.financial.surplus"] ? parseFloat(data["task.financial.surplus"]).toFixed(2) : "0.00";',
			},
		});
	columns['task.approved'] &&
		dataInput.push({
			fieldNames: ['task.approved'],
			label: 'approved',
			format: 'STRING',
			processor: 'SCRIPT',
			processorData: {
				script: 'return data["task.approved"] === "true" ? "Yes" : "No";',
			},
		});
	columns['task.labels'] &&
		dataInput.push({
			fieldNames: ['task.labels.name'],
			label: 'labels',
			processor: 'LIST',
			processorData: {
				arrayPath: 'task.labels',
				subProcessor: {
					format: 'STRING',
					fieldNames: ['name'],
					delimiter: ' ',
				},
			},
		});

	// Loop all customfield
	const customFieldsKeys = customFieldDefinitions.map(c => c.key);
	customFieldsKeys.forEach(key => {
		const label = customFieldDefinitions
			.find(def => def.key === key)
			.displayName.replace(' ', '_')
			.toLowerCase();
		const col = 'company.reportCustomFieldDefinitions.' + key;
		columns[col] &&
			dataInput.push({
				fieldNames: ['task.reportCustomFieldValues.' + key],
				label: label,
				format: 'STRING',
				processor: 'CUSTOM_FIELD',
				processorData: {
					key: key,
					fields: 'task.reportCustomFieldValues',
					script: 'return data["value"] ? data["value"] : "";',
				},
			});
	});

	return dataInput;
};
